
import YTPlayer from 'yt-player';
import { v1 as uuidv1 } from 'uuid';


export const createPerson = (data) => {
    return Object.assign({
        name: '',
        muted: false,
        color: '#CCCCCC',
        order: 0,
        tracks: {
            video: null,
            audio: null,
        },
        broadcasting: false,
        angle: 0,
        faceDistance: 0,
        pointer: null,
        x: 0,
        y: 0,
        //emote: "",
        messages: [],
        z_index: Date.now()
    }, data);
}

export const createObject = (data) => {
    return Object.assign({
        type: '',
        id: uuidv1(),
        x: 0,
        y: 0,
        z_index: Date.now(),
        options: {
            flip: false,
            rotation: 0,
            locked: false
        }
    }, data);
}

export const getItemByValue = (array, key, value) => {
    for(let i = 0; i < array.length; i++) {
        if(array[i][key] == value) {
            return array[i]
        }
    }
    return undefined;
}

export const angle = (p1, p2) => {
    var dy = p2.y - p1.y;
    var dx = p2.x - p1.x;
    var theta = Math.atan2(dy, dx); // range (-PI, PI]
    //theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
    //if (theta < 0) theta = 360 + theta; // range [0, 360)
    return theta;
}

export const distance = (p1, p2) => {
    return Math.sqrt((p1.x-p2.x)*(p1.x-p2.x) + (p1.y-p2.y)*(p1.y-p2.y));
}

/*export const isVideoInPlaylist = (video_id, playlist) => {
    return getVideoFromPlaylist(video_id, playlist) != undefined;
}*/

export const getVideoFromPlaylist = (video_id, playlist) => {
    let data;
    for(let i = 0; i < playlist.length; i++) {
        if(playlist[i].video_id == video_id) {
            data = playlist[i]
        }
    }

    return data;
}

export const initializePlayer = (element_id, video_id) => {
    const player = new YTPlayer(element_id, {
        width: '0',
        height: '0',
        playerVars: {
            autoplay: true,
        }
        
    });

    player.load(video_id, true);
    player.setPlaybackQuality('small');

    /*console.log(YT);
    let player = new YT.player(element_id, {
        height: '0',
        width: '0',
        videoId: video_id,
        playerVars: {
            autoplay: true,
        },
        events: {
            onReady() {
                player.setPlaybackQuality('small');
            },
            onStateChange(e) {
                if(e.data == YT.PlayerState.ENDED) {
                    if(events && 'ended' in events) {
                        events['ended']()
                    }
                }
            }
        }
    });*/

    return player;
}


export const choice = (A) => {
    return A[Math.floor(Math.random() * A.length)]
}

export const randint = (a, b) => {
    return Math.floor(Math.random() * (b - a + 1) + a)
}


function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;
  
    return {
      x: centerX + (radius * Math.cos(angleInRadians)),
      y: centerY + (radius * Math.sin(angleInRadians))
    };
}

export const describeArc = (x, y, radius, startAngle, endAngle) => {

    var start = polarToCartesian(x, y, radius, endAngle);
    var end = polarToCartesian(x, y, radius, startAngle);

    var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

    var d = [
        "M", start.x, start.y, 
        "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
    ].join(" ");

    return d;       
}


export const getSVGCoordinates = (e) => {
    let svg = document.querySelector('#room');

    var pt = svg.createSVGPoint();
    if(e.touches != undefined) {
        pt.x = e.touches[0].clientX;
        pt.y = e.touches[0].clientY;
    } else {
        pt.x = e.clientX;
        pt.y = e.clientY;
    }

    var cursorpt =  pt.matrixTransform(svg.getScreenCTM().inverse());

    return cursorpt;
}


export const calculateRelativePosition = (pos, rooms) => {
    let origin = {x: 0, y: 0}

    if(pos == undefined) return origin;

    if(pos.hasOwnProperty('in')) {
        origin =  calculateRelativePosition(getItemByValue(rooms, 'id', pos.in), rooms);
    }
    
    return {
        x: (pos.relx != undefined ? pos.relx : pos.x) + origin.x,
        y: (pos.rely != undefined ? pos.rely : pos.y) + origin.y
    }
}

export function downloadDataURL(dataURL, exportName){
    //var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
    var downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href",     dataURL);
    downloadAnchorNode.setAttribute("download", exportName);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
}

// modified from source: https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
export const darken = (col, percent) => {
    var usePound = false;
    if ( col[0] == "#" ) {
        col = col.slice(1);
        usePound = true;
    }

    var num = parseInt(col,16);

    var r = (num >> 16) * percent;

    if ( r > 255 ) r = 255;
    else if  (r < 0) r = 0;

    var b = ((num >> 8) & 0x00FF) * percent;

    if ( b > 255 ) b = 255;
    else if  (b < 0) b = 0;

    var g = (num & 0x0000FF) * percent;

    if ( g > 255 ) g = 255;
    else if  ( g < 0 ) g = 0;

    return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16).padStart(6, '0');
}

// this does NOT work
export const exportRoomAsImage = (room, objects) => {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');

    let roomElement = document.getElementById(`room${room.id}`);
    let objectElements = objects.map(object => document.getElementById(`object${object.id}`));

    let roomBBox = roomElement.getBBox();

    canvas.width = 1000;
    canvas.height = canvas.width / roomBBox.width * roomBBox.height;

    let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${canvas.width}" height="${canvas.height}" viewBox="${roomBBox.x} ${roomBBox.y} ${roomBBox.width} ${roomBBox.height}">
        
        ${ roomElement.outerHTML }
        ${ objectElements.map(x => x.outerHTML).join(' ') }
    </svg>`

    console.log(svg);

    var img1 = new Image();
    img1.onload = function() {
        ctx.drawImage(img1, 0, 0);

        downloadDataURL(canvas.toDataURL(), `${room.name}.png`);
        /*let a = document.createElement('a');
        a.href = canvas.toDataURL();
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);*/
    }
    img1.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);

    downloadDataURL('data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg), `${room.name}.svg`);
}


export const emoji_list = [
"face-vomiting","face-with-tongue","face-with-monocle","face-savoring-food","face-without-mouth","face-blowing-a-kiss","face-with-open-mouth","face-with-thermometer","face-screaming-in-fear","face-with-head-bandage","face-with-medical-mask","face-with-rolling-eyes","face-with-tears-of-joy","face-with-raised-eyebrow","face-with-hand-over-mouth","face-with-steam-from-nose","face-with-symbols-on-mouth","hot-face","man-facepalming","cold-face","nerd-face","zany-face","angry-face","clown-face","dizzy-face","lying-face","tired-face","weary-face","woozy-face","woman-facepalming","angry-face-with-horns","crying-face","hushed-face","sleepy-face","person-facepalming","fearful-face","flushed-face","hugging-face","kissing-face","neutral-face","pensive-face","pouting-face","smiling-face","winking-face","worried-face","yawning-face","smiling-face-with-halo","anxious-face-with-sweat","smiling-face-with-horns","smiling-face-with-hearts","winking-face-with-tongue","smiling-face-with-heart-eyes","smiling-face-with-sunglasses","kissing-face-with-closed-eyes","beaming-face-with-smiling-eyes","kissing-face-with-smiling-eyes","smiling-face-with-smiling-eyes","confused-face","drooling-face","frowning-face","grinning-face","partying-face","pleading-face","relieved-face","shushing-face","sleeping-face","smirking-face","sneezing-face","thinking-face","unamused-face","downcast-face-with-sweat","grinning-face-with-sweat","grinning-face-with-big-eyes","frowning-face-with-open-mouth","grinning-face-with-smiling-eyes","anguished-face","grimacing-face","nauseated-face","squinting-face-with-tongue","astonished-face","confounded-face","cowboy-hat-face","money-mouth-face","persevering-face","upside-down-face","disappointed-face","zipper-mouth-face","loudly-crying-face","expressionless-face","sad-but-relieved-face","slightly-smiling-face","slightly-frowning-face","grinning-squinting-face"
]

export const tempRoomData = [
    {"rooms":[{"width":500,"height":300,"x":-250,"y":-150,"name":""}],"objects":[]},
    {"rooms":[{"width":500,"height":300,"x":-250,"y":-150,"name":""}],"objects":[{"type":"","id":"041844e0-b7e3-11ea-ba2e-1962331829e2","z_index":1593199675668,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/RetroRug.svg","relx":264,"rely":133,"in":0},{"type":"","id":"087b29d0-b7e3-11ea-ba2e-1962331829e2","z_index":1593199676885,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/WickerSofa.svg","relx":259,"rely":80,"in":0},{"type":"","id":"0df37660-b7e3-11ea-ba2e-1962331829e2","z_index":1593199713355,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/unfx/Furniture/Armchair/PinkHighback.svg","relx":84,"rely":136,"in":0},{"type":"","id":"14f0b540-b7e3-11ea-ba2e-1962331829e2","z_index":1593199741141,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/DanishModernSideTable.svg","relx":226,"rely":209,"in":0},{"type":"","id":"20152fa0-b7e3-11ea-ba2e-1962331829e2","z_index":1593199678319,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/WoodSideTable.svg","relx":121,"rely":112,"in":0},{"type":"","id":"2afec3e0-b7e3-11ea-ba2e-1962331829e2","z_index":1593199785763,"options":{"flip":true,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/unfx/Furniture/Armchair/Wooden.svg","relx":372,"rely":185,"in":0},{"type":"","id":"3f8e96f0-b7e3-11ea-ba2e-1962331829e2","z_index":1593199782845,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/JapaneseFloorLamp.svg","relx":396,"rely":65,"in":0}]},
    {"rooms":[{"width":500,"height":300,"x":-250,"y":-150,"name":""}],"objects":[{"type":"","id":"5114e570-b7e1-11ea-838f-b9041feea6bb","z_index":1593199161201,"options":{"flip":true,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/unfx/Watercooler.svg","relx":75,"rely":27,"in":0},{"type":"","id":"ea03e5b0-b7e1-11ea-838f-b9041feea6bb","z_index":1593199431001,"options":{"flip":true,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/unfx/Furniture/Chair/MetalCoffee.svg","relx":428,"rely":190,"in":0},{"type":"","id":"1db69ba0-b7e2-11ea-838f-b9041feea6bb","z_index":1593199436022,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/DanishModernCoffeeTable.svg","relx":272,"rely":210,"in":0},{"type":"","id":"2b59d1a0-b7e2-11ea-838f-b9041feea6bb","z_index":1593199433938,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/BlueFireworksRug.svg","relx":271,"rely":228,"in":0},{"type":"","id":"3bc109a0-b7e2-11ea-838f-b9041feea6bb","z_index":1593199379943,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/unfx/Furniture/Armchair/LeatherLazy.svg","relx":84,"rely":195,"in":0},{"type":"","id":"6f8831f0-b7e2-11ea-838f-b9041feea6bb","z_index":1593199432334,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/DanishModernSofa.svg","relx":271,"rely":123,"in":0}]},
    {"rooms":[{"width":800,"height":500,"x":-400,"y":-250,"name":""}],"objects":[{"type":"","id":"c15997d0-b7fb-11ea-b0dd-e13007cd04d8","z_index":1593210252284,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/unfx/TreeConiferous1.svg","relx":654,"rely":53,"in":0},{"type":"","id":"d09f5a40-b7fb-11ea-b0dd-e13007cd04d8","z_index":1593210487490,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/unfx/TreeDead2.svg","relx":404,"rely":318,"in":0},{"type":"","id":"e3e7e040-b7fb-11ea-b0dd-e13007cd04d8","z_index":1593210311272,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/unfx/StoneMonument3.svg","relx":354,"rely":131,"in":0},{"type":"","id":"f9f1f740-b7fb-11ea-b0dd-e13007cd04d8","z_index":1593210349973,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/unfx/TreeConiferous4.svg","relx":60,"rely":29,"in":0},{"type":"","id":"477d0a40-b7fc-11ea-b0dd-e13007cd04d8","z_index":1593210679743,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/unfx/JujuGrandmaChair.svg","relx":240,"rely":321,"in":0},{"type":"","id":"bdd9ca70-b7fc-11ea-b0dd-e13007cd04d8","z_index":1593210677386,"options":{"flip":false,"rotation":0,"locked":false},"svg":"https://assets.cozyroom.xyz/objects/TreeTrunk.svg","relx":384,"rely":412,"in":0}]},
]